var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sq",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 512,
    height: 512,
    fill: "#d80027"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M352.464,212.006H290.647A22.257,22.257,0,1,0,256,184.335a22.258,22.258,0,1,0-34.647,27.671H159.536c0,16.393,14.278,29.68,30.67,29.68h-.988A29.682,29.682,0,0,0,218.9,271.368a29.491,29.491,0,0,0,3.842,14.6l-24.619,24.621,18.888,18.888L243.8,302.678a20.438,20.438,0,0,0,3.257.9l-16.191,36.557L256,367.3l25.13-27.167L264.939,303.58a20.3,20.3,0,0,0,3.257-.9l26.794,26.794,18.888-18.888-24.621-24.621a29.494,29.494,0,0,0,3.842-14.6,29.682,29.682,0,0,0,29.682-29.682h-.988C338.186,241.686,352.464,228.4,352.464,212.006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSq);
export default __webpack_public_path__ + "static/media/sq.43fe7f93dd4d1316135fe3f16369157d.svg";
export { ForwardRef as ReactComponent };